import styles from "./NavTopBarBodyEnd.module.scss"
import { NavTopBarBodyEndProps } from "./NavTopBarBodyEnd.types"

export default function NavTopBarBodyEnd(props: NavTopBarBodyEndProps) {
    const { children } = props

    return <div className={styles.base}>{children}</div>
}
